import SearchDispatch from './SearchDispatch'

export default SearchDispatch
